'use strict';

/** @type {import('.')} */
module.exports = Error;



//////////////////
// WEBPACK FOOTER
// ../~/es-errors/index.js
// module id = 506
// module chunks = 0